import {
    CREATE_BRAND_SUCCESS,
    UPDATE_BRAND_SUCCESS,
    LOAD_BRAND_SUCCESS,
    CLEAR_BRAND,
    UPDATE_BRAND_IMAGE_SUCCESS,
    UPDATE_BRAND_LOGO_SUCCESS,
    DELETE_BACKGROUND_IMAGE_SUCCESS,
    TOGGLE_CHAIN_LEVEL_PROMOTION_SETTINGS
} from '../../actions/types';

const INITIAL_STATE = {};

export default (state=INITIAL_STATE, action) => {

    const { type, payload } = action;

    switch(type) {
        case CREATE_BRAND_SUCCESS:
            return payload;
        case UPDATE_BRAND_SUCCESS:
            return payload;
        case UPDATE_BRAND_IMAGE_SUCCESS:
            return {
                ...state,
                bannerImagePath: payload.bannerImagePath
            };
        case UPDATE_BRAND_LOGO_SUCCESS:
            return {
                ...state,
                smallLogoFilePath: payload.smallLogoFilePath
            };
        case DELETE_BACKGROUND_IMAGE_SUCCESS:
            return {
                ...state,
                customerFrontEndTheme: payload
            }    
        case LOAD_BRAND_SUCCESS:
            return payload;
        case TOGGLE_CHAIN_LEVEL_PROMOTION_SETTINGS:
            return {
                ...state,
                chainLevelPromotionSettings: payload
            };
        case CLEAR_BRAND:      
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/brands/BrandReducer.js